import React from 'react';
import moment from 'moment-timezone';
import {Box} from "@mui/material";
import {blue, grey} from "@mui/material/colors";

import PerformerMetrics from '../common/PerformerMetrics';
import {DATE_ONLY_FORMAT} from "../../config/DateTimeConstants";

const cellDisabledGreyColor = grey[200];
const todayCellBlueColor = blue[50];

const styles = {
    calendarDateCell: {
        position: 'relative',
        height: '100%',
        width: '100%',
        border: '0.031rem solid',
        borderColor: grey[300],
    },
    performerBookingAndMetrics: {
        position: 'absolute',
        bottom: '-0.063rem',
        backgroundColor: 'white',
        color: 'black',
        padding: '0.1rem',
        fontSize: '0.875rem',
        textAlign: 'center',
        width: '100%',
        zIndex: 5,
    }
};

const getDateCellBackgroundColor = (isInCurrentMonth, isToday) => {
    if (isToday) {
        return todayCellBlueColor;
    }

    if (!isInCurrentMonth) {
        return cellDisabledGreyColor;
    }

    return 'white';
};

export default function SchedulePlannerPerformerMetricCellWrapper({
    children,
    value,
    currentDate,
    timezone,
    shiftPlansByDateMap,
    bookingStatsData,
    performerMetricsByDate
}) {
    const startOfMonth = moment(currentDate).tz(timezone).startOf('month');
    const endOfMonth = moment(currentDate).tz(timezone).endOf('month');
    const cellDate = moment(value).tz(timezone);
    const today = moment().tz(timezone).startOf('day');

    const isInCurrentMonth = cellDate.isBetween(startOfMonth, endOfMonth, 'day', '[]');
    const isToday = cellDate.isSame(today, 'day');
    const backgroundColor = getDateCellBackgroundColor(isInCurrentMonth, isToday);
    const dateKey = moment(value).tz(timezone).format(DATE_ONLY_FORMAT);

    return (
        <Box sx={{...styles.calendarDateCell, backgroundColor}}>
            {children}
            {
                isInCurrentMonth
                &&
                <Box sx={styles.performerBookingAndMetrics}>
                    <PerformerMetrics
                        shiftPlans={shiftPlansByDateMap.get(dateKey) || []}
                        currentDate={value}
                        bookingStats={bookingStatsData?.bookingStats}
                        performerMetrics={performerMetricsByDate.get(dateKey)}
                    />
                </Box>
            }
        </Box>
    );
}
